import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Dots",
  "use": "Dots-usage",
  "viewBox": "0 0 8 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 34\" id=\"Dots\"><path fill-rule=\"evenodd\" d=\"M0 .5h7.5V8H0V.5zm0 12.75h7.5v7.5H0v-7.5zM0 26h7.5v7.5H0V26z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol